// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"cpu","clipPath":"url(#clip0_543_1945)"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 4H20V20H4V4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 9H15V15H9V9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 8H1.5M8 4V1.5M16 4V1.5M20 16H22.5M20 8H22.5M8 20V22.5M16 20V22.5M4 16H1.5M4 4H20V20H4V4Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 9H15V15H9V9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-cpu')
export default class CpuIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cpu',
    }
  }
}
